import React, { Component, Fragment } from 'react';
import { connect } from 'react-redux';
import ReactDOM from 'react-dom';
import {
  Nav,
  NavItem,
  UncontrolledCollapse,
  ModalHeader,
  ModalBody,
  Modal,
  Collapse,
} from 'reactstrap';
import { NavLink } from 'react-router-dom';
import classnames from 'classnames';
import PerfectScrollbar from 'react-perfect-scrollbar';
import { withRouter, Redirect } from 'react-router-dom';
import {
  AxiosAPI,
  getGroupID,
  getUserID,
  getUserRole,
} from '../../helpers/AxiosAPI';
import {
  gAPI_Internal_Property_By_Id,
  gAPI_Group_By_Id,
  gAPI_Site_Settings,
  gAPI_CheckUser_Groups,
} from '../../constants/APIs';
import IntlMessages from '../../helpers/IntlMessages';
import meetingroom_logo from '../../assets/meeting-room.png';
import {
  setContainerClassnames,
  addContainerClassname,
  changeDefaultClassnames,
  changeSelectedMenuHasSubItems,
  changeDomains,
  ChangeGroupId,
  CheckVoucherEngine,
} from '../../redux/actions';
import { isDarkSwitchActive } from '../../constants/defaultValues';
import menuItems from '../../constants/menu';
import dialogLogins from '../../data/dialogLogins';
import VirtualFront from '../../assets/virtual_front.svg';

import workFlow from '../../assets/workFlow.svg';
import { fetchServiceRequest } from '../../redux/service/actions';
import knowlegeHub from '../../assets/knowlegeHub.png';
class Sidebar extends Component {
  constructor(props) {
    super(props);
    this.toggleModel = this.toggleModel.bind(this);
    this.state = {
      selectedParentMenu: '',
      viewingParentMenu: '',
      domains: [],
      isAvailable: false,
      isWhatsNewVisible: false,
      isVirtualFrontDesk: false,
      isRateBooking: false,
      isGuestService: false,
      isGuestMessaging: false,
      trainingCollpase: true,
      publishCollpase: true,
      widgetCollpase: true,
      roomCollpase: true,
      flowCollpase: true,
      copilotCollpase: true,
      isSuperAdmin: false,
    };
  }

  handleWindowResize = (event) => {
    if (event && !event.isTrusted) {
      return;
    }
    const { containerClassnames } = this.props;
    let nextClasses = this.getMenuClassesForResize(containerClassnames);
    this.props.setContainerClassnames(
      0,
      nextClasses.join(' '),
      this.props.selectedMenuHasSubItems
    );
  };

  handleDocumentClick = (e) => {
    const container = this.getContainer();
    let isMenuClick = false;
    if (
      e.target &&
      e.target.classList &&
      (e.target.classList.contains('menu-button') ||
        e.target.classList.contains('menu-button-mobile'))
    ) {
      isMenuClick = true;
    } else if (
      e.target.parentElement &&
      e.target.parentElement.classList &&
      (e.target.parentElement.classList.contains('menu-button') ||
        e.target.parentElement.classList.contains('menu-button-mobile'))
    ) {
      isMenuClick = true;
    } else if (
      e.target.parentElement &&
      e.target.parentElement.parentElement &&
      e.target.parentElement.parentElement.classList &&
      (e.target.parentElement.parentElement.classList.contains('menu-button') ||
        e.target.parentElement.parentElement.classList.contains(
          'menu-button-mobile'
        ))
    ) {
      isMenuClick = true;
    }
    if (container.contains(e.target) || container === e.target || isMenuClick) {
      return;
    }
    this.setState({
      viewingParentMenu: '',
    });
    this.toggle();
  };

  getMenuClassesForResize = (classes) => {
    const { menuHiddenBreakpoint, subHiddenBreakpoint } = this.props;
    let nextClasses = classes.split(' ').filter((x) => x !== '');
    const windowWidth = window.innerWidth;
    if (windowWidth < menuHiddenBreakpoint) {
      nextClasses.push('menu-mobile');
    } else if (windowWidth < subHiddenBreakpoint) {
      nextClasses = nextClasses.filter((x) => x !== 'menu-mobile');
      if (
        nextClasses.includes('menu-default') &&
        !nextClasses.includes('menu-sub-hidden')
      ) {
        nextClasses.push('menu-sub-hidden');
      }
    } else {
      nextClasses = nextClasses.filter((x) => x !== 'menu-mobile');
      if (
        nextClasses.includes('menu-default') &&
        nextClasses.includes('menu-sub-hidden')
      ) {
        nextClasses = nextClasses.filter((x) => x !== 'menu-sub-hidden');
      }
    }
    return nextClasses;
  };

  getContainer = () => {
    return ReactDOM.findDOMNode(this);
  };

  toggle = () => {
    const hasSubItems = this.getIsHasSubItem();
    this.props.changeSelectedMenuHasSubItems(hasSubItems);
    const { containerClassnames, menuClickCount } = this.props;
    const currentClasses = containerClassnames
      ? containerClassnames.split(' ').filter((x) => x !== '')
      : '';
    let clickIndex = -1;

    if (!hasSubItems) {
      if (
        currentClasses.includes('menu-default') &&
        (menuClickCount % 4 === 0 || menuClickCount % 4 === 3)
      ) {
        clickIndex = 1;
      } else if (
        currentClasses.includes('menu-sub-hidden') &&
        (menuClickCount === 2 || menuClickCount === 3)
      ) {
        clickIndex = 0;
      } else if (
        currentClasses.includes('menu-hidden') ||
        currentClasses.includes('menu-mobile')
      ) {
        clickIndex = 0;
      }
    } else {
      if (currentClasses.includes('menu-sub-hidden') && menuClickCount === 3) {
        clickIndex = 2;
      } else if (
        currentClasses.includes('menu-hidden') ||
        currentClasses.includes('menu-mobile')
      ) {
        clickIndex = 0;
      }
    }
    if (clickIndex >= 0) {
      this.props.setContainerClassnames(
        clickIndex,
        containerClassnames,
        hasSubItems
      );
    }
  };

  handleProps = () => {
    this.addEvents();
  };

  addEvents = () => {
    ['click', 'touchstart', 'touchend'].forEach((event) =>
      document.addEventListener(event, this.handleDocumentClick, true)
    );
  };

  removeEvents = () => {
    ['click', 'touchstart', 'touchend'].forEach((event) =>
      document.removeEventListener(event, this.handleDocumentClick, true)
    );
  };

  setSelectedLiActive = (callback) => {
    const oldli = document.querySelector('.sub-menu  li.active');
    if (oldli != null) {
      oldli.classList.remove('active');
    }

    /* set selected parent menu */
    const selectedlink = document.querySelector('.sub-menu  a.active');
    if (selectedlink != null) {
      selectedlink.parentElement.classList.add('active');
      this.setState(
        {
          selectedParentMenu:
            selectedlink.parentElement.parentElement.getAttribute(
              'data-parent'
            ),
        },
        callback
      );
    } else {
      var selectedParentNoSubItem = document.querySelector(
        '.main-menu  li a.active'
      );
      if (selectedParentNoSubItem != null) {
        this.setState(
          {
            selectedParentMenu:
              selectedParentNoSubItem.getAttribute('data-flag'),
          },
          callback
        );
      } else if (this.state.selectedParentMenu === '') {
        if (menuItems[0].to === window.location.pathname) {
          this.setState(
            {
              selectedParentMenu: menuItems[0].id,
            },
            callback
          );
        }
      }
    }
  };

  setHasSubItemStatus = () => {
    const hasSubmenu = this.getIsHasSubItem();
    this.props.changeSelectedMenuHasSubItems(hasSubmenu);
    this.toggle();
  };

  getIsHasSubItem = () => {
    const { selectedParentMenu } = this.state;
    const menuItem = menuItems.find((x) => x.id === selectedParentMenu);
    if (menuItem)
      return menuItem && menuItem.subs && menuItem.subs.length > 0
        ? true
        : false;
    else return false;
  };

  checkMenuAccess = (menudomains, type) => {
    if (type !== undefined) {
      const userId = getUserID();
      const login = dialogLogins.filter(
        (m) =>
          m.label === type && m.logins.filter((l) => l === userId).length > 0
      );
      if (login.length > 0 && type !== 'sa') {
        return true;
      } else if (type === 'sa' && this.props.isMymaSuperAdmin === true) {
        return true;
      } else {
        return false;
      }
    }
    if (menudomains !== undefined) {
      // if(this.state.isAvailable)
      let hasAccess = false;

      this.state.domains.forEach((p) => {
        menudomains.forEach((r) => {
          if (this.state.isAvailable) {
            if (p.type === r) {
              hasAccess = true;
            }
          } else {
            if (p.type === r) {
              hasAccess = true;
            }
          }
        });
      });
      return hasAccess;
    } else return true;
  };

  checkSpaceBookingVisible = (type) => {
    if (type === 'spaceBookings') {
      if (this.state.isSpaceBooking) {
        return true;
      } else {
        return false;
      }
    } else {
      return true;
    }
  };

  checkVirtualMenuVisible = (type) => {
    if (type === 'virtualfrontdesk') {
      if (this.state.isVirtualFrontDesk) {
        return true;
      } else {
        return false;
      }
    } else if (type === 'ratesbookings') {
      if (this.state.isRateBooking) {
        return true;
      } else {
        return false;
      }
    }
    else if (type === 'guestmessaging') {
      if (this.state.isGuestMessaging) {
        return true;
      } else {
        return false;
      }
    } else {
      return true;
    }
  };
  checkSubMenuVisible(menudomains, type) {
    let hasAccess = false;
    if (menudomains !== undefined) {
      menudomains.forEach((r) => {
        if (r === 'AccommodationProviders') {
          hasAccess = true;
        }
      });
    }
    if (hasAccess && type === 'menu.guestservice') {
      if (this.state.isGuestService) {
        return true;
      } else {
        return false;
      }
    } else {
      return true;
    }
  }

  checkGuestMessagingSubVisible = (subLabel) => {
    const role = this.props.role || getUserRole();
    const { isMymaSuperAdmin } = this.props;

    if (isMymaSuperAdmin === true) {
      return true;
    }

    if (!subLabel.startsWith('guest-messaging')) {
      return true;
    }
    if (role === 'Agent') {
      return (
        subLabel === 'guest-messaging.insights_logs' ||
        subLabel === 'guest-messaging.reservations'
      );
    }
    if (role === 'Admin' || role === 'User') {
      return true;
    }
    return false;
  };

  componentDidUpdate(prevProps) {
    if (this.props.location.pathname !== prevProps.location.pathname) {
      this.setSelectedLiActive(this.setHasSubItemStatus);
      // Hide the menu after click
      let nextClasses = ['menu-sub-hidden'];
      this.props.setContainerClassnames(
        0,
        nextClasses.join(' '),
        this.props.selectedMenuHasSubItems
      );
      window.scrollTo(0, 0);
    }
    this.handleProps();
  }

  componentDidMount() {
    const { serviceProvider, fetchServiceRequest } = this.props;
    if (serviceProvider) {
      fetchServiceRequest(serviceProvider);
    }
    if (this.props.pid === '-1') {
      AxiosAPI({
        method: 'get',
        url: `${gAPI_Group_By_Id}/${getGroupID()}`,
      }).then((g) => {
        const allgroups = [{ type: 'AllGroups', priority: 1 }];
        if (g.data.domain !== '') {
          allgroups.push({ type: g.data.domain, priority: 1 });
        }
        this.setState({ domains: allgroups, isVirtualFrontDesk: true });
        this.props.CheckVoucherEngine(false);
        this.props.changeDomains(allgroups);
      });
    } else {
      AxiosAPI({
        method: 'get',
        url: `${gAPI_Internal_Property_By_Id}/${this.props.pid
          }?group_id=${getGroupID()}`,
      })
        .then((res) => {
          let val = 0;
          res.data.domains.map((d) => {
            if (d.type === 'VoucherEngine') {
              val = 1;
            }
          });
          if (val === 1) {
            this.setState({ isAvailable: true });
            this.props.CheckVoucherEngine(true);
            this.props.ChangeGroupId(getGroupID());
          } else {
            this.props.CheckVoucherEngine(false);
            this.props.ChangeGroupId(getGroupID());
          }
          this.setState({
            domains: res.data.domains,
            isVirtualFrontDesk: res.data.isVirtualFrontDesk,
            isRateBooking: res.data.isRateBooking,
            isGuestService: res.data.isGuestService,
            isSpaceBooking: res.data.isSpaceBooking,
            isGuestMessaging: res.data.isGuestMessaging,
          });
          this.props.changeDomains(res.data.industryDomains);

        })
        .catch((err) => console.error(err));
    }
    AxiosAPI({
      methhod: 'get',
      url: `${gAPI_CheckUser_Groups}/${getUserID()}`,
    }).then((res) => {
      if (res.data.status === undefined) this.setState({ isSuperAdmin: true });
    });
    window.addEventListener('resize', this.handleWindowResize);
    this.handleWindowResize();
    this.handleProps();
    this.setSelectedLiActive(this.setHasSubItemStatus);
    const selectedParent = menuItems.filter(
      (f) => f.to === window.location.pathname
    );
    if (selectedParent !== undefined && selectedParent.length === 0) {
      this.props.changeSelectedMenuHasSubItems(false);
      this.setState({
        viewingParentMenu: '',
        selectedParentMenu: '',
      });
      this.toggle();
    } else if (
      (selectedParent !== undefined && selectedParent.length > 0) ||
      (selectedParent[0].subs === undefined &&
        selectedParent[0].subs.length === 0)
    ) {
      this.props.changeSelectedMenuHasSubItems(false);
      this.setState({
        viewingParentMenu: '',
        selectedParentMenu: '',
      });
      this.toggle();
    }
  }

  componentWillUnmount() {
    this.removeEvents();
    window.removeEventListener('resize', this.handleWindowResize);
  }

  openSubMenu = (e, menuItem) => {

    const selectedParent = menuItem.id;
    const hasSubMenu = menuItem.subs && menuItem.subs.length > 0;
    this.props.changeSelectedMenuHasSubItems(hasSubMenu);
    if (!hasSubMenu) {
      this.setState({
        viewingParentMenu: selectedParent,
        selectedParentMenu: selectedParent,
      });
      this.toggle();
    } else {
      e.preventDefault();

      const { containerClassnames, menuClickCount } = this.props;
      const currentClasses = containerClassnames
        ? containerClassnames.split(' ').filter((x) => x !== '')
        : '';

      if (!currentClasses.includes('menu-mobile')) {
        if (
          currentClasses.includes('menu-sub-hidden') &&
          (menuClickCount === 2 || menuClickCount === 0)
        ) {
          this.props.setContainerClassnames(3, containerClassnames, hasSubMenu);
        } else if (
          currentClasses.includes('menu-hidden') &&
          (menuClickCount === 1 || menuClickCount === 3)
        ) {
          this.props.setContainerClassnames(2, containerClassnames, hasSubMenu);
        } else if (
          currentClasses.includes('menu-default') &&
          !currentClasses.includes('menu-sub-hidden') &&
          (menuClickCount === 1 || menuClickCount === 3)
        ) {
          this.props.setContainerClassnames(0, containerClassnames, hasSubMenu);
        }
      } else {
        this.props.addContainerClassname(
          'sub-show-temporary',
          containerClassnames
        );
      }
      this.setState({
        viewingParentMenu: selectedParent,
      });
    }
  };
  toggleModel = (e) => {
    const isWhatsNewVisible = this.state.isWhatsNewVisible;
    this.setState({ isWhatsNewVisible: !isWhatsNewVisible });
  };
  trainingCategory = (sub) => {
    const { featuresUrl } = this.props;

    const includedCategories = [
      'property-info.faq',
      'property-info.room-types',
      'property-info.documents',
      'menu.product_services',
      'property-info.publish-ai',
      'property-info.assistant-options',
      'property-info.external-sources',
      'property-info.about-properties',
    ];

    if (featuresUrl && !featuresUrl.includes('concierge.synxis.com')) {
      includedCategories.push('property-info.pre-built-templates');
    }

    return includedCategories.includes(sub.label);
  };
  render() {
    var restUrl = window.location.href.substring(
      window.location.href.length,
      window.location.href.lastIndexOf('/') + 1
    );
    const match = this.props.match;
    const {
      selectedParentMenu,
      viewingParentMenu,
      domains,
      isWhatsNewVisible,
    } = this.state;

    const { role, locale, featuresUrl } = this.props;
    const url = this.props.featureUpdateUrl?.startsWith('http')
      ? this.props.featureUpdateUrl
      : `https://${this.props.featureUpdateUrl}`;

    const submenuTrain = (item, type) => {
      if (type === 'training') {
        return item.subs
          .filter((sub) => sub.filter === 'training')
          .filter((sub) => this.trainingCategory(sub))
          .map((sub, index) => {
            if (
              this.checkMenuAccess(sub.domains, sub.type) === true &&
              this.checkSubMenuVisible(sub.domains, sub.label) === true &&
              this.checkGuestMessagingSubVisible(sub.label) === true
            )
              return (
                <NavItem key={`${item.id}_${index}`}>
                  {sub.newWindow ? (
                    <a href={sub.to} rel="noopener noreferrer" target="_blank">
                      <i className={sub.icon} /> <IntlMessages id={sub.label} />
                    </a>
                  ) : sub.subs && sub.subs.length > 0 ? (
                    <Fragment>
                      <NavLink to={sub.to} id={`${item.id}_${index}`}>
                        <i className={sub.icon} />{' '}
                        <IntlMessages id={sub.label} />
                      </NavLink>

                      <UncontrolledCollapse toggler={`#${item.id}_${index}`}>
                        <Nav className="third-level-menu">
                          {sub.subs.map((thirdSub, thirdIndex) => {
                            return (
                              <NavItem
                                key={`${item.id}_${index}_${thirdIndex}`}
                              >
                                {thirdSub.newWindow ? (
                                  <a
                                    href={thirdSub.to}
                                    rel="noopener noreferrer"
                                    target="_blank"
                                  >
                                    <i className={thirdSub.icon} />{' '}
                                    <IntlMessages id={thirdSub.label} />
                                  </a>
                                ) : (
                                  <NavLink to={thirdSub.to}>
                                    <i className={thirdSub.icon} />{' '}
                                    <IntlMessages id={thirdSub.label} />
                                  </NavLink>
                                )}
                              </NavItem>
                            );
                          })}
                        </Nav>
                      </UncontrolledCollapse>
                    </Fragment>
                  ) : (
                    <NavLink to={sub.to}>
                      <i className={sub.icon} /> <IntlMessages id={sub.label} />
                    </NavLink>
                  )}
                </NavItem>
              );
          });
      }
      // Handle other types (rooms, flow, etc.)
      return null;
    };
    const submenu = (item, val) => {
      let menus = item.subs
        .filter((f) => f.filter === val)
        .map((sub, index) => {
          if (sub.label === 'property-info.publish-ai' && locale !== 'en') {
            return null;
          }
          if (
            this.checkMenuAccess(sub.domains, sub.type) === true &&
            this.checkSubMenuVisible(sub.domains, sub.label) === true &&
            this.checkGuestMessagingSubVisible(sub.label) === true
          )
            return (
              <NavItem key={`${item.id}_${index}`}>
                {sub.newWindow ? (
                  <a href={sub.to} rel="noopener noreferrer" target="_blank">
                    <i className={sub.icon} /> <IntlMessages id={sub.label} />
                  </a>
                ) : sub.subs && sub.subs.length > 0 ? (
                  <Fragment>
                    <NavLink to={sub.to} id={`${item.id}_${index}`}>
                      <i className={sub.icon} /> <IntlMessages id={sub.label} />
                    </NavLink>

                    <UncontrolledCollapse toggler={`#${item.id}_${index}`}>
                      <Nav className="third-level-menu">
                        {sub.subs.map((thirdSub, thirdIndex) => {
                          return (
                            <NavItem key={`${item.id}_${index}_${thirdIndex}`}>
                              {thirdSub.newWindow ? (
                                <a
                                  href={thirdSub.to}
                                  rel="noopener noreferrer"
                                  target="_blank"
                                >
                                  <i className={thirdSub.icon} />
                                  {''}
                                  <IntlMessages id={thirdSub.label} />
                                </a>
                              ) : (
                                <NavLink to={thirdSub.to}>
                                  <i className={thirdSub.icon} />
                                  {''}
                                  <IntlMessages id={thirdSub.label} />
                                </NavLink>
                              )}
                            </NavItem>
                          );
                        })}
                      </Nav>
                    </UncontrolledCollapse>
                  </Fragment>
                ) : (
                  <NavLink to={sub.to}>
                    <i className={sub.icon} /> <IntlMessages id={sub.label} />
                  </NavLink>
                )}
              </NavItem>
            );
        });

      return menus;
    };
    const filterMenuByUser = (menuItems) => {
      const role = getUserRole();
      let list = menuItems;
      const isSubMenu =
        menuItems.length > 0 &&
        menuItems[0].label &&
        !menuItems[0].label.startsWith('menu.');
      if (role === 'User') {
        list = menuItems.filter((l) => l.label !== 'menu.userroles');
      }
      else if (role === 'Agent') {
        if (!isSubMenu) {
          list = menuItems.filter(
            (l) =>
              l.label === 'menu.conversations.unified-inbox' ||
              l.label === 'menu.guest-messaging'
          );
        }

      }
      else if (role === 'NA') {
        list = [];
      }
      if (this.state.isSuperAdmin !== true) {
        list = list.filter((l) => l.label !== 'menu.myAccounts');
      }
      return list;
    };

    return (
      <Fragment>
        <div className="sidebar">
          <div className="main-menu">
            <div className="scroll">
              <PerfectScrollbar
                option={{ suppressScrollX: true, wheelPropagation: false }}
              >
                <Nav vertical className="list-unstyled">
                  {menuItems &&
                    filterMenuByUser(menuItems).map((item) => {
                      if (
                        (role === 'Admin' ||
                          (role === 'User' &&
                            item.label !== 'menu.admin' &&
                            item.label !== 'menu.userroles') ||
                          (role === 'Agent' &&
                            item.label !== 'menu.admin' &&
                            item.label !== 'menu.userroles')) &&
                        this.checkMenuAccess(item.domains, item.type) ===
                        true &&
                        this.checkVirtualMenuVisible(item.id) === true &&
                        this.checkSpaceBookingVisible(item.id) === true
                      )
                        return (
                          <NavItem
                            key={item.id}
                            className={classnames({
                              active:
                                (selectedParentMenu === item.id &&
                                  viewingParentMenu === '') ||
                                viewingParentMenu === item.id,
                            })}
                          >
                            {item.newWindow ? (
                              <a
                                href={item.to}
                                rel="noopener noreferrer"
                                target="_blank"
                              >
                                <i className={item.icon} />{' '}
                                <IntlMessages id={item.label} />
                              </a>
                            ) : (
                              <Fragment>
                                {item.label === 'dashboards.space-booking' ? (
                                  <NavLink
                                    to={item.to}
                                    onClick={(e) => this.openSubMenu(e, item)}
                                    data-flag={item.id}
                                  >
                                    <img
                                      width={30}
                                      src={meetingroom_logo}
                                    ></img>
                                    <IntlMessages id={item.label} />
                                  </NavLink>
                                ) : (
                                  <NavLink
                                    to={item.to}
                                    onClick={(e) => this.openSubMenu(e, item)}
                                    data-flag={item.id}
                                  >
                                    {item.id === 'virtualfrontdesk' ||
                                      item.id === 'workflows' ||
                                      item.image === 'knowlegeHub' ? (
                                      <i
                                        className={item.icon}
                                        style={{ fontSize: '25px' }}
                                      />
                                    ) : (
                                      <Fragment className="mb-2">
                                        <i
                                          className={item.icon}
                                          style={{ fontSize: '30px' }}
                                        />
                                      </Fragment>
                                    )}{' '}
                                    <IntlMessages id={item.label} />
                                  </NavLink>
                                )}
                              </Fragment>
                            )}
                          </NavItem>
                        );
                    })}
                </Nav>
              </PerfectScrollbar>
              <div className="sidebar-menu-whatsnew">
                <a
                  rel="noopener noreferrer"
                  target="_blank"
                  href={
                    this.props.featureUpdateUrl
                      ? url
                      : 'https://help.myma.ai/en/articles/8126626-what-s-new'
                  }
                >
                  <IntlMessages id="menu.whatsnew"></IntlMessages>
                </a>
              </div>
            </div>
          </div>

          <div className="sub-menu">
            <div className="scroll">
              <PerfectScrollbar
                option={{ suppressScrollX: true, wheelPropagation: false }}
              >
                {menuItems &&
                  menuItems.map((item) => {
                    return (
                      <Nav
                        key={item.id}
                        className={classnames({
                          'd-block':
                            (this.state.selectedParentMenu === item.id &&
                              this.state.viewingParentMenu === '') ||
                            this.state.viewingParentMenu === item.id,
                        })}
                        data-parent={item.id}
                      >
                        {item.subs && item.subs.length > 0 && (
                          <Fragment>
                            {item.subs
                              .filter((f) => f.filter === 'training')
                              .filter(
                                (sub, index) =>
                                  this.checkMenuAccess(
                                    sub.domains,
                                    sub.type
                                  ) === true &&
                                  this.checkSubMenuVisible(
                                    sub.domains,
                                    sub.label
                                  ) === true
                              ).length > 0 && (
                                <NavItem className={'has-sub-item'}>
                                  <NavLink
                                    className={`rotate-arrow-icon opacity-50 ${this.state.trainingCollpase === false
                                      ? 'collapsed'
                                      : ''
                                      }`}
                                    to={'#'}
                                    onClick={(e) =>
                                      this.setState({
                                        trainingCollpase:
                                          !this.state.trainingCollpase,
                                      })
                                    }
                                  >
                                    <i className="simple-icon-arrow-down" />
                                    <IntlMessages id="property-info.trainig-data" />
                                  </NavLink>
                                  <Collapse isOpen={this.state.trainingCollpase}>
                                    {submenuTrain(item, 'training')}
                                  </Collapse>
                                </NavItem>
                              )}
                          </Fragment>
                        )}

                        {item.subs && item.subs.length > 0 && (
                          <Fragment>
                            {item.subs
                              .filter((f) => f.filter === 'publish')
                              .filter(
                                (sub, index) =>
                                  this.checkMenuAccess(
                                    sub.domains,
                                    sub.type
                                  ) === true &&
                                  this.checkSubMenuVisible(
                                    sub.domains,
                                    sub.label
                                  ) === true
                              ).length > 0 && (
                                <NavItem className={'has-sub-item'}>
                                  <NavLink
                                    className={`rotate-arrow-icon opacity-50 ${this.state.publishCollpase === false
                                      ? 'collapsed'
                                      : ''
                                      }`}
                                    to={'#'}
                                    onClick={(e) =>
                                      this.setState({
                                        publishCollpase:
                                          !this.state.publishCollpase,
                                      })
                                    }
                                  >
                                    <i className="simple-icon-arrow-down" />
                                    <IntlMessages id="property-info.publishMonitor" />
                                  </NavLink>
                                  <Collapse isOpen={this.state.publishCollpase}>
                                    {submenu(item, 'publish')}
                                  </Collapse>
                                </NavItem>
                              )}
                          </Fragment>
                        )}

                        {item.subs && item.subs.length > 0 && (
                          <Fragment>
                            {item.subs
                              .filter((f) => f.filter === 'widget')
                              .filter(
                                (sub, index) =>
                                  this.checkMenuAccess(
                                    sub.domains,
                                    sub.type
                                  ) === true &&
                                  this.checkSubMenuVisible(
                                    sub.domains,
                                    sub.label
                                  ) === true
                              ).length > 0 && (
                                <NavItem className={'has-sub-item'}>
                                  <NavLink
                                    className={`rotate-arrow-icon opacity-50 ${this.state.widgetCollpase === false
                                      ? 'collapsed'
                                      : ''
                                      }`}
                                    to={'#'}
                                    onClick={(e) =>
                                      this.setState({
                                        widgetCollpase:
                                          !this.state.widgetCollpase,
                                      })
                                    }
                                  >
                                    <i className="simple-icon-arrow-down" />
                                    <IntlMessages id="property-info.webWidget" />
                                  </NavLink>
                                  <Collapse isOpen={this.state.widgetCollpase}>
                                    {submenu(item, 'widget')}
                                  </Collapse>
                                </NavItem>
                              )}
                          </Fragment>
                        )}

                        {item.subs && item.subs.length > 0 && (
                          <Fragment>
                            {item.subs
                              .filter((f) => f.filter === 'rooms')
                              .filter(
                                (sub, index) =>
                                  this.checkMenuAccess(
                                    sub.domains,
                                    sub.type
                                  ) === true &&
                                  this.checkSubMenuVisible(
                                    sub.domains,
                                    sub.label
                                  ) === true
                              ).length > 0 && (
                                <NavItem className={'has-sub-item'}>
                                  <NavLink
                                    className={`rotate-arrow-icon opacity-50 ${this.state.roomCollpase === false
                                      ? 'collapsed'
                                      : ''
                                      }`}
                                    to={'#'}
                                    onClick={(e) =>
                                      this.setState({
                                        roomCollpase: !this.state.roomCollpase,
                                      })
                                    }
                                  >
                                    <i className="simple-icon-arrow-down" />
                                    <IntlMessages id="property-info.media" />
                                  </NavLink>
                                  <Collapse isOpen={this.state.roomCollpase}>
                                    {submenu(item, 'rooms')}
                                  </Collapse>
                                </NavItem>
                              )}
                          </Fragment>
                        )}

                        {item.subs && item.subs.length > 0 && (
                          <Fragment>
                            {item.subs
                              .filter((f) => f.filter === 'copilot')
                              .filter(
                                (sub, index) =>
                                  this.checkMenuAccess(
                                    sub.domains,
                                    sub.type
                                  ) === true &&
                                  this.checkSubMenuVisible(
                                    sub.domains,
                                    sub.label
                                  ) === true
                              ).length > 0 && (
                                <NavItem className={'has-sub-item'}>
                                  <NavLink
                                    className={`rotate-arrow-icon opacity-50 ${this.state.copilotCollpase === false
                                      ? 'collapsed'
                                      : ''
                                      }`}
                                    to={'#'}
                                    onClick={(e) =>
                                      this.setState({
                                        copilotCollpase:
                                          !this.state.copilotCollpase,
                                      })
                                    }
                                  >
                                    <i className="simple-icon-arrow-down" />{' '}
                                    <IntlMessages id="property-info.copilot" />
                                  </NavLink>
                                  <Collapse isOpen={this.state.copilotCollpase}>
                                    {submenu(item, 'copilot')}
                                  </Collapse>
                                </NavItem>
                              )}
                          </Fragment>
                        )}

                        {item.subs && item.subs.length > 0 && (
                          <Fragment>
                            {filterMenuByUser(item.subs)
                              .filter(
                                (sub) =>
                                  sub.filter === undefined &&
                                  sub.filter !== 'copilot' &&
                                  sub.filter !== 'flow' &&
                                  sub.filter !== 'rooms' &&
                                  sub.filter !== 'publish' &&
                                  sub.filter !== 'widget' &&
                                  sub.filter !== 'training' &&
                                  this.checkMenuAccess(sub.domains, sub.type) === true &&
                                  this.checkSubMenuVisible(sub.domains, sub.label) === true &&
                                  this.checkGuestMessagingSubVisible(sub.label) === true
                              )
                              .map((sub, index) => {
                                if (sub.label === 'Setup Wizard') {
                                  return null;
                                }

                                if (
                                  sub.label === 'virtual-front.outbound' &&
                                  featuresUrl &&
                                  featuresUrl.includes('concierge.synxis.com')
                                ) {
                                  return null;
                                }
                                return (
                                  <NavItem key={`${item.id}_${index}`}>
                                    {sub.newWindow ? (
                                      <Fragment>
                                        <a
                                          href={sub.to}
                                          rel="noopener noreferrer"
                                          target="_blank"
                                        >
                                          <i className={sub.icon} />{' '}
                                          <IntlMessages id={sub.label} />
                                        </a>
                                      </Fragment>
                                    ) : sub.subs && sub.subs.length > 0 ? (
                                      <Fragment>
                                        <NavLink
                                          to={sub.to}
                                          id={`${item.id}_${index}`}
                                        >
                                          <i className={sub.icon} />{' '}
                                          <IntlMessages id={sub.label} />
                                        </NavLink>

                                        <UncontrolledCollapse
                                          toggler={`#${item.id}_${index}`}
                                        >
                                          <Nav className="third-level-menu">
                                            {sub.subs.map(
                                              (thirdSub, thirdIndex) => {
                                                return (
                                                  <NavItem
                                                    key={`${item.id}_${index}_${thirdIndex}`}
                                                  >
                                                    {thirdSub.newWindow ? (
                                                      <a
                                                        href={thirdSub.to}
                                                        rel="noopener noreferrer"
                                                        target="_blank"
                                                      >
                                                        <i
                                                          className={
                                                            thirdSub.icon
                                                          }
                                                        />{' '}
                                                        <IntlMessages
                                                          id={thirdSub.label}
                                                        />
                                                      </a>
                                                    ) : (
                                                      <NavLink
                                                        to={thirdSub.to}
                                                      >
                                                        <i
                                                          className={
                                                            thirdSub.icon
                                                          }
                                                        />{' '}
                                                        <IntlMessages
                                                          id={thirdSub.label}
                                                        />
                                                      </NavLink>
                                                    )}
                                                  </NavItem>
                                                );
                                              }
                                            )}
                                          </Nav>
                                        </UncontrolledCollapse>
                                      </Fragment>
                                    ) : (
                                      <NavLink to={sub.to}>
                                        <i className={sub.icon} />{' '}
                                        <IntlMessages id={sub.label} />
                                      </NavLink>
                                    )}
                                  </NavItem>
                                );
                              })}
                          </Fragment>
                        )}
                      </Nav>
                    );
                  })}
              </PerfectScrollbar>
            </div>
          </div>
        </div>
        <Modal
          isOpen={isWhatsNewVisible}
          toggle={this.toggleModel}
          size="lg"
          style={{ maxWidth: '1024px' }}
        >
          <ModalHeader toggle={this.toggleModel}></ModalHeader>
          <ModalBody>
            <iframe
              src="https://pages.bookmebob.com/feature-updates"
              width="950"
              height="700"
              frameBorder="0"
            />
          </ModalBody>
        </Modal>
      </Fragment>
    );
  }
}

const mapStateToProps = ({ menu, settings, usersListApp, service }) => {
  const {
    containerClassnames,
    subHiddenBreakpoint,
    menuHiddenBreakpoint,
    menuClickCount,
    selectedMenuHasSubItems,
  } = menu;
  const { locale, propertyId, serviceProvider } = settings;
  const { isMymaSuperAdmin } = usersListApp;
  const { featuresUrl, featureUpdateUrl } = service;
  return {
    containerClassnames,
    subHiddenBreakpoint,
    menuHiddenBreakpoint,
    menuClickCount,
    selectedMenuHasSubItems,
    locale,
    propertyId,
    serviceProvider,
    isMymaSuperAdmin,
    featuresUrl,
    featureUpdateUrl
  };
};
export default withRouter(
  connect(mapStateToProps, {
    setContainerClassnames,
    addContainerClassname,
    changeDefaultClassnames,
    changeSelectedMenuHasSubItems,
    changeDomains,
    CheckVoucherEngine,
    ChangeGroupId,
    fetchServiceRequest,
  })(Sidebar)
);
